import { render, staticRenderFns } from "./CollectMoney.vue?vue&type=template&id=bace0990&scoped=true&"
import script from "./CollectMoney.vue?vue&type=script&lang=js&"
export * from "./CollectMoney.vue?vue&type=script&lang=js&"
import style0 from "./CollectMoney.vue?vue&type=style&index=0&id=bace0990&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bace0990",
  null
  
)

export default component.exports